<template>
  <q-page class="main">
    <div class="row justify-center items-center q-pa-xl">
      <q-card class="col-12 col-md-8">
        <q-card-section class="q-pa-lg">
          <h1 class="heading-2 q-mb-lg">{{ title }}</h1>
          <slot>
            {{ content }}
          </slot>
        </q-card-section>
      </q-card>
    </div>
  </q-page>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    }
  }
}
</script>
